import React, { useCallback } from 'react';

import classNames from 'classnames';
import './Hamburger.scss';

export default function Hamburger({ isOpen, setIsOpen }) {
    const handleOnClick = useCallback(() => {
        let open = isOpen;
        setIsOpen(!open);
    });

    const getAriaLabel = isOpen ? 'Close main menu' : 'Open main menu';

    return (
        <button
            className={classNames({
                'navigation-hamburger': true,
                'is-open': isOpen,
                'is-closed': !isOpen,
            })}
            onClick={handleOnClick}
            title="Open main menu"
            data-tesid={'hamburger'}
            aria-label={getAriaLabel}
            aria-controls="mobile-navigation"
            id="hamburger"
        >
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
        </button>
    );
}
